<template>
    <div
        class="kgr-profileImage kgr-profileImage--inline"
        :class="sizeClass"
    >
        <kgr-image
            :src="src"
            :alt="alt"
            :circle="true"
            css-class="kgr-profileImage__image"
        />
    </div>
</template>

<script>
import Image from '../common/Image';

export default {
    components: {
        'kgr-image': Image,
    },
    props: {
        src: {
            type: String,
            required: true,
            example: 'https://picsum.photos/200/200/?random',
        },
        alt: {
            type: String,
            required: false,
            example: 'Awesome image',
        },
        size: {
            type: String,
            required: false,
            example: 'L',
            default: 'M',
        },
    },
    computed: {
        sizeClass() {
            return `kgr-profileImage--size${this.size}`;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
